// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("@/assets/svg/banner-bg.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".left-section[data-v-bafde72e]{height:100vh}.h-max-content[data-v-bafde72e]{height:-webkit-max-content;height:-moz-max-content;height:max-content}.sidebar[data-v-bafde72e]{max-width:400px;width:25%;min-height:100vh}.banner[data-v-bafde72e]{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-position:50% -16px}", ""]);
// Exports
module.exports = exports;
